import { useState, useRef, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMasterContext } from "../../provider/MasterProvider";
import { useParksContext } from "../../provider/ParksProvider";
import { debounce } from "lodash";
import apiCall from "../Api/api";

const SafariParkSearch = () => {
  const location = useLocation();

  const { parksWithSlug, animals, animalsDefault, locations, vehicles, masterDispatch } = useMasterContext();
  const { filters, filterdPark, parkSearch, animalSearch, selectedPark, parksDispatch } = useParksContext();
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    parksDispatch({ type: "SET_FILTERD_PARK_DATA", payload: parksWithSlug });
  }, [parksWithSlug]);

  //handles dropdown
  const toggleDropdown = (dropdown) => {
    setOpenDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  useEffect(() => {
    if (location.pathname === '/') {
      parksDispatch({ type: "SET_SELECTED_PARK", payload: 0 });
    }
     if (location.pathname === '/park') {
      parksDispatch({ type: "SET_SELECTED_PARK", payload: 0 });
    }
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  //on Select Location, Animal, Vehicle
  const updateFilter = (name, value) => {
    parksDispatch({ type: "SET_PAGE_INDEX", payload: 1 });
    parksDispatch({
      type: "UPDATE_PARKS_FILTER",
      payload: { [name]: value },
    });
  };

  //On select Park
  const viewPark = (park) => {
    parksDispatch({ type: "SET_PARK_SEARCH", payload: '' }); // reset search value
    parksDispatch({ type: "SET_FILTERD_PARK_DATA", payload: parksWithSlug }); // reset options
    parksDispatch({ type: "SET_SELECTED_PARK", payload: park?.value });
    if (park?.value === 0) return;
    navigate(`/park/${park?.slug}`)
  }

  //on Click Search Button
  const handleSearchClick = () => {
    navigate('/park')
  }

  const debouncedFetchAnimals = useCallback(
    debounce(async (value) => {
      if (value.trim().length === 0) {
        masterDispatch({ type: "SET_MASTER_ANIMALS", payload: animalsDefault });
        return;
      }

      try {
        const response = await apiCall({
          url: `master/animal?is_searchable=1&status=1&name=${encodeURIComponent(value)}&pageSize=50`,
          method: "GET",
        });

        const data = response?.data?.master_animal?.data || [];

        const options = data.map((animal) => ({
          label: animal.name,
          value: animal.id,
        }));

        masterDispatch({ type: "SET_MASTER_ANIMALS", payload: options });
      } catch (error) {
        console.error("Error fetching animals:", error);
      }
    }, 300), [animalsDefault, masterDispatch]);

  const handleAnimalSearch = (e) => {
    const value = e.target.value;
    parksDispatch({ type: "SET_ANIMAL_SEARCH", payload: value });
    debouncedFetchAnimals(value);
  };

  const handleParkSearch = (e) => {
    const value = e.target.value;
    parksDispatch({ type: "SET_PARK_SEARCH", payload: value });
    const filtered = parksWithSlug.filter(park =>
      park.label.toLowerCase().includes(value)
    );
    parksDispatch({ type: "SET_FILTERD_PARK_DATA", payload: filtered });
  }

  return (
    <>
      <div className="row gx-0 justify-content-center">
        <div className="col-xl-10 col-xxl-9 planSearch_box">
          <div className="select_searcjBox d-sm-flex flex-wrap align-items-center gap-1 w-100 justify-content-center" ref={dropdownRef}>
            <div className="select_boxes position-relative">
              <div className="dropdown-container">
                <div className="dropdown-toggle" tabIndex="0" onClick={() => toggleDropdown("park")}>
                  {parksWithSlug?.find((park) => park?.value === selectedPark)?.label || "All / Any"}
                </div>
                {openDropdown === "park" && (
                  <div className="dropdown custom_dropdown">
                    <div className="form-group animal_search_container">
                      <span className="fa fa-search form-control-feedback"></span>
                      <input type="text"
                        className="form-control animal_search"
                        placeholder="Search Park"
                        value={parkSearch}
                        onChange={handleParkSearch}
                      />
                    </div>
                    {filterdPark?.map((park, index) => (
                      <div key={index} className="dropdown-item" onClick={() => { viewPark(park); setOpenDropdown(null); }}>
                        {park?.label}
                      </div>
                    ))}
                  </div>
                )}
                <div className="placeholder_select"><p>Select Park</p></div>
                <div className="OrBox"><p>OR</p></div>
              </div>
            </div>

            <div className="select_boxes position-relative">
              <div className="dropdown-container">
                <div className="dropdown-toggle" tabIndex="0" onClick={() => toggleDropdown("location")}>
                  {locations?.find((loc) => loc?.value === filters?.master_location_id)?.label || "All / Any"}
                </div>
                {openDropdown === "location" && (
                  <div className={`dropdown custom_dropdown`}>
                    {locations?.map((location, index) => (
                      <div key={index}
                        className={`dropdown-item ${location?.value === filters?.master_location_id ? 'active' : ''}`}
                        onClick={() => { updateFilter('master_location_id', location?.value); setOpenDropdown(null); }}
                      >
                        {location?.label}
                      </div>
                    ))}
                  </div>
                )}
                <div className="placeholder_select loc"><p>Location</p></div>
              </div>
            </div>

            <div className="select_boxes position-relative">
              <div className="dropdown-container">
                <div className="dropdown-toggle" tabIndex="0" onClick={() => toggleDropdown("animal")}>
                  {animals?.find((animal) => animal?.value === filters?.master_animal_id)?.label || "All / Any"}
                </div>
                {openDropdown === "animal" && (
                  <div className="dropdown custom_dropdown">
                    <div className="form-group animal_search_container">
                      <span className="fa fa-search form-control-feedback"></span>
                      <input type="text"
                        className="form-control animal_search"
                        placeholder="Search Animal"
                        value={animalSearch}
                        onChange={handleAnimalSearch}
                      />
                    </div>
                    <div id="master_animal_dropdown">
                      {animals?.map((animal, index) => (
                        <div key={index}
                          className={`dropdown-item ${animal?.value === filters?.master_animal_id ? 'active' : ''}`}
                          onClick={() => { updateFilter('master_animal_id', animal?.value); setOpenDropdown(null); }}>
                          {animal?.label}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <div className="placeholder_select"><p>Animal</p></div>
              </div>
            </div>

            <div className="select_boxes position-relative">
              <div className="dropdown-container">
                <div className="dropdown-toggle" tabIndex="0" onClick={() => toggleDropdown("vehicle")}>
                  {vehicles?.find((vehi) => vehi?.value === filters?.master_vehicle_id)?.label || "All / Any"}
                </div>
                {openDropdown === "vehicle" && (
                  <div className="dropdown custom_dropdown">
                    {vehicles.map((vehicle, index) => (
                      <div key={index}
                        className={`dropdown-item ${vehicle?.value === filters?.master_vehicle_id ? 'active' : ''}`}
                        onClick={() => { updateFilter('master_vehicle_id', vehicle?.value); setOpenDropdown(null); }}
                      >
                        {vehicle?.label}
                      </div>
                    ))}
                  </div>
                )}
                <div className="placeholder_select"><p>Vehicle</p></div>
              </div>
            </div>

          </div>
        </div>

        <div className="col-xl-1">
          <div className="search px_serach">
            <div className="serch_btn">
              <button id="search_submit_btn" onClick={handleSearchClick}>Search</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );

};

export default SafariParkSearch;
